export default "__VITE_PUBLIC_ASSET__1b031c76__"